export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_ROLE = 'SET_CURRENT_USER_ROLE';
export const TOGGLE_SIDENAV = 'TOGGLE_SIDENAV';
